import { render, staticRenderFns } from "./1008.vue?vue&type=template&id=8dd7d59e&scoped=true&"
import script from "./1008.vue?vue&type=script&lang=js&"
export * from "./1008.vue?vue&type=script&lang=js&"
import style0 from "./1008.vue?vue&type=style&index=0&id=8dd7d59e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd7d59e",
  null
  
)

export default component.exports